import { hideLinkToken } from './link-token';

// Imported first in the entry point, before either session recorder initialises, so the
// credential in the address bar is gone before anything reads the URL. See `link-token.js`.
hideLinkToken();
